import { render, staticRenderFns } from "./StrategyBlock.vue?vue&type=template&id=5c656a05"
import script from "./StrategyBlock.vue?vue&type=script&lang=js"
export * from "./StrategyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports